import { CalendarDateFormatter, DateFormatterParams } from 'angular-calendar';
import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable()
export class CustomDateFormatter extends CalendarDateFormatter {

  public override monthViewColumnHeader({ date, locale }: DateFormatterParams): string {
    return formatDate(date, 'EEE', locale);
  }

  public override weekViewColumnHeader({ date, locale }: DateFormatterParams): string {
    if (locale === 'he') {
      return formatDate(date, 'EEE', locale).replace('יום ', '').charAt(0);
    }
    return formatDate(date, 'EEE', locale);
  }

  public override dayViewHour({ date, locale }: DateFormatterParams): string {
    return formatDate(date, 'HH:mm', locale);
  }

  public override weekViewHour({ date, locale }: DateFormatterParams): string {
    return formatDate(date, 'HH:mm', locale);
  }
  
  public dayViewHourSegment({ date, locale }: DateFormatterParams): string {
    return formatDate(date, 'HH:mm', locale); 
  }
}
